export const environment = {
  production: false,
  service: {
    url: 'https://dev-api-normateca.laureate.mx',
    jwt: {
      username: 'normatecaminerateartquake',
      password: 'wu!e!rEkl#-PH0wrE3@6L$5Oq'
    },
  },
  session: {
    secret: 'wu!e!rEkl#-PH0wrE3@6L$5Oq'
  },
};
